import { metaDataTypes } from "Uitls/Util";

export const fetchIndicationsFilter = (data, selectedIndications) => {
  if (data.length > 0) {
    return data.map((indication, index) => {
      return {
        id: index,
        displayName: indication.indicationName,
        veevaId: indication.indicationDamId,
        metaDataType: metaDataTypes.indication,
      };
    });
  }
  return [];
};

export const fetchDocumentIndicationsFilter = (data) => {
  if (data.length > 0) {
    return data.map((indication, index) => {
      return {
        id: index,
        displayName: indication.name__v,
        veevaId: indication.id,
        metaDataType: metaDataTypes.documentIndication,
      };
    });
  }
  return [];
};
